import React, { useEffect, useState } from 'react';
import { Route, Switch, Redirect } from 'react-router';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory, useLocation, Link } from 'react-router-dom';
import { setComplete } from '../../actions/user-api';
import $ from 'jquery';

// Anticipa
// ==========================================
// Anticipa: Common
import { Navbar } from './_common/navbar';
import { Help } from './_common/help';
import JwtDecode from 'jwt-decode';
// Anticipa: Views
import {Onboard} from './onboard';
import {Dashboard} from './dashboard';
import {Referent} from './referent';
import {Communes} from './communes';
import {Personal} from './personal';
import {Biblioteque} from './biblioteque';
import { Settings } from './settings';
import { Events } from "./events";
import SigninIlustration from './../../assets/images/placeholder/Signin-ilustration.svg';
import * as Loadings from '../../constants/loadings/user';
import {FileTypes} from '../../constants/utils/fileTypes';
import * as R from 'ramda';
import * as axios from 'axios';
import {getUserAddress, getUserRepresentatives, getUserRepresentativeAddress, getUserServices, getDocuments, getProfilePicture, fetchUserById, getUserMessage, fetchPartnerCustomization} from '../../actions/user-api';
import { fetchLifeEvents } from "../../actions/events-api";
import {fetchAllServiceData} from '../../actions/services-api';

import * as ActionTypes from "../../constants/actiontypes/user";


export const Anticipa = () => {
	const user = useSelector(state => state.user);
	// const auth = useSelector(state => state.auth);
	const router = useSelector(state => state.router);
	const dispatch = useDispatch();

	const location = useLocation();
	const history = useHistory();

	const queryParams = new URLSearchParams(location.search);
	if(queryParams.has('fc')){
		$('#commencerAnticipa').modal('show');
	}

	useEffect(() => {
		let authToken = sessionStorage.getItem("access_token");
		if (!R.isNil(authToken)) {
		  axios.defaults.headers.common['Authorization'] = "Bearer " + authToken;
		}
	  }, [])

	useEffect(() => {
		if (user.user === undefined && !user.isLoading.includes(Loadings.FETCH_USER)) {
			var accessToken = sessionStorage.getItem("access_token");
			if (accessToken !== undefined && accessToken !== null && accessToken !== '') {
			  var decoded = JwtDecode(accessToken);
			  if (!R.isNil(decoded) && !R.isNil(decoded["http://schemas.xmlsoap.org/ws/2005/05/identity/claims/nameidentifier"])) {
				dispatch(fetchUserById(decoded["http://schemas.xmlsoap.org/ws/2005/05/identity/claims/nameidentifier"]));
			  }
			}
		}else{
			let tmpUser = user.user;
			if (!R.isNil(tmpUser)) {
				if(!R.isNil(tmpUser.partnerId) && tmpUser.partnerId !== '00000000-0000-0000-0000-000000000000'){					
					dispatch(fetchPartnerCustomization(tmpUser.partnerId));
				}else{
					dispatch({type: ActionTypes.FETCH_PARTNER_CUSTOMIZATION_DEFAULT_SUCCESS})
				}
			}
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [user.user]);

	useEffect(() => {
		if (!R.isNil(user.user)) {
			dispatch(getUserAddress(user.user.id));
			dispatch(getUserRepresentatives(user.user.id));
			dispatch(getUserServices(user.user));
			dispatch(getDocuments(user.user));
			dispatch(getUserMessage());
			dispatch(fetchAllServiceData("Relocation"));
			dispatch(fetchLifeEvents(user.user.id));
		}
	}, [user.partnerCustomization]);

	useEffect(() => {
		const profilePicture = user.documents.find(d => d.fileType === FileTypes.ProfilePicture);
		if(!R.isNil(profilePicture))
			dispatch(getProfilePicture(user.user.id, profilePicture.fileName));
	}, [user.documents]);

	useEffect(() => {
		if(!R.isNil(user.referents) && user.referents.length > 0){
			user.referents.forEach(r => {
			dispatch(getUserRepresentativeAddress(r))
			});
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [user.referents]);

	let authToken = sessionStorage.getItem("access_token");
    if (R.isNil(authToken)) {
		return (
			<div className={"layout layout-row" + (!R.isNil(user.partnerCustomization) && !R.isNil(user.partnerCustomization.color) && user.partnerCustomization.color !== "" ? "" : " bg-gradient-primary")} style={{ backgroundColor: "#" + user.partnerCustomization.color }}>
				<h1 className="sr-only visually-hidden">Assist@</h1>
				<Navbar location={router.location} user={user.user} logoContent={user.partnerCustomization.logoBase64Encoded} />
				<main role="main" className="view flex-grow-1 bg-gradient-light">
					<section className="flex-column align-items-center justify-content-center h-inherit">
						<img className="img-fluid img-contain mx-auto mb-4" src={SigninIlustration} alt="Assist@" />
						<div className="block text-center">
							<h1 className="font-weight-bolder ls-n1 lh-1">Votre session a expiré</h1>
							<p className="o-80 mb-4">Vous devrez vous reconnecter avec votre compte Assist@ pour continuer.</p>
							<Link
								to="/auth/signin"
								type="button"
								className="btn btn-primary px-4 rounded-sm"
								onClick={() => {
									sessionStorage.removeItem("access_token");
								}}>
								OK
							</Link>
						</div>
					</section>
				</main>
			</div>
		);
	}

	if (R.isNil(user.user) || !user.partnerCustomization.isLoaded) {
		return "";
	}

	let step = !R.isNil(user.user.onBoardingStep) ? parseInt(JSON.stringify(user.user.onBoardingStep).replace(/\D/g, "")) : -1;
	if (step !== 6 && step !== -1) {
		if(user.user.onBoardingStep !== "Completed"){
			window.location = `/auth/signup/step${(step+1)}${location.search}`;
			return '';
		}
	}

	return (
		<div className={"layout layout-row" + (!R.isNil(user.partnerCustomization) && !R.isNil(user.partnerCustomization.color) && user.partnerCustomization.color !== "" ? "" : " bg-gradient-primary")} style={{ backgroundColor: "#" + user.partnerCustomization.color }}>
			<h1 className="sr-only visually-hidden">Assist@</h1>
			<Navbar location={router.location} user={user.user} profilePicture={user.profilePicture} profilePictureDocument={user.documents.find((d) => d.fileType === FileTypes.ProfilePicture)} logoContent={user.partnerCustomization.logoBase64Encoded} />
			<main role="main" className="view flex-grow-1 bg-gradient-light">
				<h1 className="sr-only visually-hidden">Assist@: Main</h1>
				<Help />
				{!R.isNil(user.user.setupCompletedDate) ? (
					<Switch>
						<Route path="/anticipa/dashboard/" component={Dashboard} />
						<Route path="/anticipa/referent/" component={Referent} />
						<Route path="/anticipa/communes/" component={Communes} />
						<Route path="/anticipa/personal/" render={() => (<Personal isDemo={R.isNil(user.partnerCustomization) ? false : user.partnerCustomization.isDemo} />)} />

						<Route path="/anticipa/biblioteque/">
							<Biblioteque userId={user.user.id} files={user.documents} isLoading={user.isLoading} recipientEmail={user.user.recipientEmail} />
						</Route>
						<Route path="/anticipa/settings/" component={Settings} />
						<Route path="/anticipa/events/" component={Events} />
						<Route
							render={() => {
								return <Redirect exact to={"/anticipa/dashboard"} />;
							}}
						/>
					</Switch>
				) : (
					<Switch>
						<Route exact path="/anticipa" component={Onboard} />
						<Route path="/anticipa/referent/" component={Referent} />
						<Route path="/anticipa/communes/" component={Communes} />
						<Route path="/anticipa/personal/" render={() => (<Personal isDemo={R.isNil(user.partnerCustomization) ? false : user.partnerCustomization.isDemo} />)} />
						<Route path="/anticipa/events/" component={Events} />
						<Route path="/anticipa/biblioteque/">
							<Biblioteque userId={user.user.id} files={user.documents} isLoading={user.isLoading} recipientEmail={user.user.recipientEmail} />
						</Route>
						<Route path="/anticipa/settings/" component={Settings} />

						<Route
							render={() => {
								return <Redirect exact to={"/anticipa"} />;
							}}
						/>
					</Switch>
				)}
			</main>
			{router.location.pathname.toLowerCase() === "/anticipa" ? (
				<div className="modal fade px-0" id="commencerAnticipa" aria-labelledby="commencerAnticipaLabel" aria-hidden="true">
					<div className="modal-dialog px-2">
						<div className="modal-content">
							<div className="modal-body">
								<div className="container-copy">
									<h5 className="h1 text-primary font-weight-bolder ls-n1 lh-copy mb-0 mt-4 mt-lg-auto text-uppercase" id="commencerAnticipaLabel">
										Astuces:
									</h5>
									<p className="h3 lh-copy mt-2">Conseils pour faciliter votre expérience</p>
								</div>
								<hr className="my-4" />
								<ul className="list-unstyled lh-base mb-3">
									<p className="fs-inherit mb-2">
										Vous pouvez compléter votre dossier <b>en une seule fois</b> (15 à 30 minutes) ou <b>progressivement</b>, au fur et à mesure que vous recevez vos courriers, emails et documents.
									</p>
									<p className="fs-inherit mb-2">
										Notre plateforme est <b>simple et sécurisée</b>. Aucune donnée financière ne sera partagée. Vous n'avez besoin que de vos <b>références et numéros</b> pour que vos services puissent vous identifier.
									</p>
									<p className="fs-inherit mb-2">
										Pour vous aider à remplir votre dossier rapidement et <b>éviter les déplacements</b>, nous vous conseillons d'avoir les documents suivants à portée de main :
									</p>
									<li>
										<span className="o-60 mr-2">—</span> <b>Dossier impôts</b>
									</li>
									<li>
										<span className="o-60 mr-2">—</span> <b>Dossier maison</b> : <span className="o-80">électricité, gaz, internet, eau, etc.</span>
									</li>
									<li>
										<span className="o-60 mr-2">—</span> <b>Dossiers bancaires et assurances</b>
									</li>
									<li>
										<span className="o-60 mr-2">—</span>
										<b> Carte de mutuelle</b>
									</li>
								</ul>
								<p className="fs-inherit mb-3">
									Des <b>espaces commentaires</b> sont disponibles pour chaque abonnement ou placement. Vous pouvez y noter vos montants de prélèvements ou capitaux pour un <b>suivi personnel</b>. Ces informations sont <b>strictement confidentielles</b> et ne seront jamais visibles ni utilisées dans vos courriers.
									<br />
									Ce service est conçu pour vous offrir plus de <b>flexibilité et de confort</b> dans la gestion de votre dossier.
								</p>
								<p className="fs-inherit">Bon dossier,</p>
							</div>
							<div className="modal-footer mt-4 mt-lg-auto py-2">
								<button
									type="button"
									className="btn btn-info"
									data-dismiss="modal"
									onClick={(e) => {
										e.preventDefault();
										history.replace({
											search: "",
										});
									}}>
									Commencer
								</button>
							</div>
						</div>
					</div>
				</div>
			) : (
				""
			)}
		</div>
	);
}
